module.exports = "/wwwroot/img/SHP.png?ver=ba809f2e";